import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PDP from '@components/sec_pdp/component';
import store from '@utils/store';
import { isBrowser } from '@utils';
import MetaTags from '../seo/MetaTags/component';
import StructuredData from '../seo/StructuredData/component';
import { Product } from '@utils/product';
import { SEO } from '@config';

const { organization = {} } = SEO;

const ProductDetailPage = (props) => {
  let initialProduct = [{}];
  const serverHasProduct = !!props?.staticContext?.data;
  if (serverHasProduct) {
    initialProduct = props?.staticContext?.data;
  } else if (isBrowser && window.__INITIAL_DATA__) {
    initialProduct = window.__INITIAL_DATA__;
    // delete window.__INITIAL_DATA__;
  }

  const [product, setProduct] = useState(initialProduct[0]);
  const productClass = new Product(product);
  let addtionalMetaTags = [];

  // Get all autors and sepperate their names with a custom seperator
  const persons = (seperator) => {
    return product.persons?.map((person) => {
      return person.name;
    }).join(seperator);
  };

  if (productClass.isBook) {
    addtionalMetaTags = [
      { property: 'og:type', content: 'book' },
      { property: 'book:isbn', content: product.SKU },
      { property: 'book:author', content: persons(', ') },
      { property: 'book:release_date', content: productClass.releaseDate },
    ];
  }

  // Overwrite productType label for some product types
  const productTypeLabel = () => {
    const map = {
      paperback: 'Boek',
      hardcover: 'Boek',
    };
    return map[product.type?.toLowerCase()] || product.type;
  };

  // Hardcoded SEO texts
  const pageTitle = [[product.name, persons(', ')].filter(Boolean).join(', '), productTypeLabel(), product.SKU].filter(Boolean).join(' | ');
  const pageDescription = [`Bestel ${product.name}`, persons(' en ')].filter(Boolean).join(' van ');

  return (
    <div>
      <MetaTags
        page="pdp"
        title={pageTitle}
        description={pageDescription}
        image={organization.url + productClass.images?.frontImage}
        url={organization.url + productClass.url}
        additionalTags={addtionalMetaTags}
        routeId={props.routeId}
      />
      <StructuredData type="product" product={product}/>
      <StructuredData type="breadcrumbs" breadcrumbs={product.breadcrumb}/>

      <PDP store={store} updateProduct={setProduct} {...props}/>
    </div>
  );
};

ProductDetailPage.propTypes = {
  staticContext: PropTypes.object,
  routeId: PropTypes.string,
};

export default ProductDetailPage;
